<template>
  <b-card class="text-center">
    <template #header>
      <template v-if="me">My location</template>
      <template v-else>Location</template>
    </template>
    <div class="ml-4 mr-4 mb-2">
      <company-icon :style="{fontSize: '1.5rem'}" class="m-3" />
      <h5 v-if="profile" class="font-weight-bold">{{profile.officeLocation}}</h5>
      <div v-if="timezone">{{timezone}}</div>
    </div>
  </b-card>
</template>

<script>
import { getTimezone } from '@/helpers/helpers'
import CompanyIcon from '@/assets/images/company.svg'

export default {
  name: 'UserLocation',

  props: {
    me: {
      type: Boolean,
      default: false
    },

    profile: {
      type: Object,
      required: true
    }
  },

  computed: {
    timezone() {
      const { timezone } = this.profile
      if (timezone) {
        const tz = getTimezone(timezone)
        return tz ? tz.label : ''
      }
      return ''
    }
  },

  components: {
    CompanyIcon
  }
}
</script>
